import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { STATE_KEYS } from '@shared/services';
import { IModalDialogOptions } from '@shared/types';
import { Observable, rx, Subscription } from '@shared/rx';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { XVIFormModalComponent } from '@components/form-modal/form-modal.component';
import { findIndex, get, isEqual, map, some } from 'lodash';
import { ModalService } from '@shared/helpers/modal-helpers';
import { select } from '@angular-redux/store';
import { MODAL_CONTAINER } from '../container-modal/container-modal.component';

@Component({
  selector: 'xvi-modals-controller',
  templateUrl: 'modals-controller.component.html',
  styleUrls: ['modals-controller.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XVIModalsControllerComponent implements OnInit, OnDestroy {
  @select(STATE_KEYS.FORM_MODAL)
  public entityModals$: Observable<IModalDialogOptions[]>;

  public bsModalRefs: BsModalRef[] = [];
  private subs: Subscription[] = [];

  public constructor(private readonly modalService: ModalService) {}

  public ngOnInit(): void {
    this.subs.push(
      this.entityModals$
        .pipe(rx.distinctUntilChanged(isEqual))
        .subscribe((options: IModalDialogOptions) =>
          this.updateModalsState(options),
        ),
    );
  }

  public ngOnDestroy(): void {
    this.subs.forEach((subscriptions) => subscriptions.unsubscribe());
  }

  private updateModalsState(options: IModalDialogOptions): void {
    const { modalId, visible } = options;
    const existingModals = map(this.bsModalRefs, (ref) => ref.content);
    const isCurrentModalExist = some(existingModals, { modalId } as any);

    if (!isCurrentModalExist && visible) {
      this.openModal(options);
    }

    if (isCurrentModalExist && !visible) {
      this.hideModal(modalId);
    }
  }

  private openModal(options): void {
    const defaultOptions: ModalOptions = {
      backdrop: 'static',
    };
    const userOptions: ModalOptions = {
      class: `xux-form-modal ${get(options, 'modalClass', '')}`,
      keyboard: false,
      initialState: {
        options,
      },
    };

    const modalOptions: ModalOptions = { ...defaultOptions, ...userOptions };

    const bsModalServiceInstance =
      this.modalService.getBsModalServiceInstance();
    const modalComponent = get(
      MODAL_CONTAINER,
      options.modalComp,
      XVIFormModalComponent,
    );
    this.bsModalRefs.push(
      bsModalServiceInstance.show(modalComponent, modalOptions),
    );
  }

  private hideModal(modalId: string): void {
    const currentModalIndex = findIndex(this.bsModalRefs, {
      content: { modalId },
    } as any);
    if (currentModalIndex < 0) return;

    this.bsModalRefs[currentModalIndex]?.hide();
    this.bsModalRefs.splice(currentModalIndex, 1);
  }
}
